<template>
  <v-layout>
    <v-flex v-if="reportsPending">
      <v-flex>
        Getting IPAddress log...
        <v-progress-linear indeterminate></v-progress-linear>
      </v-flex>
    </v-flex>
    <v-flex v-else>
      <v-layout column full-width>
        <v-layout row>
          <v-flex>
            <v-autocomplete
              label="Employee"
              :items="selectableEmployees"
              item-text="name"
              item-value="id"
              v-model="selectedEmployeeID"
              :loading="employeeApiCallPending"
              :disabled="employeeApiCallPending"
              clearable
            ></v-autocomplete>
          </v-flex>
          <template>
            <v-flex>
              <v-menu
                ref="startDateMenu"
                v-model="startDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template slot="activator" slot-scope="{ on }">
                  <v-text-field
                    label="Start Date"
                    format="dddd, MM DD YYYY"
                    @change="(value) => (startDate = value)"
                    :value="dateFormatted(startDate)"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :show-current="endDate" v-model="startDate" @input="startDateMenu = false" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-flex>
          </template>
          <template>
            <v-flex>
              <v-menu
                ref="endDateMenu"
                v-model="endDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template slot="activator" slot-scope="{ on }">
                  <v-text-field
                    label="End Date"
                    format="dddd, MM DD YYYY"
                    @change="(value) => (endDate = value)"
                    :value="dateFormatted(endDate)"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :show-current="startDate" v-model="endDate" @input="endDateMenu = false" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-flex>
          </template>
          <v-flex>
            <v-btn @click="getReports" color="primary">Change Dates</v-btn>
            <v-btn @click="csvExport" color="primary" v-if="report.length > 0">
              Export
              <v-icon>arrow_downward</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

        <v-flex grow>
          <v-data-table
            :items="report"
            :headers="headers"
            item-key="worksite_id"
            class="elevation-1"
            :defaultSort="{
              sortBy: '',
              ascending: true,
              rowsPerPage: 100,
            }"
          >
            <template slot="items" slot-scope="{ item }">
              <tr>
                <td>
                  {{ item.created_at | moment("MMMM Do YYYY, h:mm:ss a") }}
                </td>
                <td>{{ item.ip }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import reportApi from "../../api/reports";
import collectionApi from "../../api/collections";
import { ExportToCsv } from "export-to-csv";
import _ from "lodash";

export default {
  computed: {
    ...mapState("userAuth", ["user"]),

    formattedQuery: function () {
      return {
        employeeID: this.selectedEmployeeID,
        startDate: this.startDate,
        endDate: this.endDate,
      };
    },
  },
  created() {
    this.setUp();
  },
  watch: {
    selectedEmployeeID(val) {
      if (val) {
        this.$router.push({
          query: {
            employeeID: parseInt(val),
            startDate: this.startDate,
            endDate: this.endDate,
          },
        });
        this.getReports();
      }
    },
  },

  data: function () {
    return {
      selectableEmployees: [],
      selectedEmployeeID: null,
      employeeApiCallPending: false,
      startDateMenu: false,
      endDateMenu: false,
      startDate: this.$moment().subtract(2, "weeks").format("YYYY-MM-DD"),
      endDate: this.$moment().subtract(1, "weeks").format("YYYY-MM-DD"),

      limit: 40,
      page: 1,

      reportsPending: true,
      report: {},
      headers: [
        { text: "Date & Time", value: "created_at", sortable: true },
        { text: "IP Address", value: "ip", sortable: true },
      ],
    };
  },

  methods: {
    setUp: function () {
      if (this.$route.query && this.$route.query.employeeID) {
        this.selectedEmployeeID = parseInt(this.$route.query.employeeID);
        this.startDate = this.$route.query.startDate || this.startDate;
        this.endDate = this.$route.query.endDate || this.endDate;
      }

      this.getEmployees();
      this.getReports();
    },

    dateFormatted: function (date) {
      return date ? this.$moment(date).format("dddd, MMMM D") : "";
    },

    getEmployees() {
      this.employeeApiCallPending = true;
      collectionApi.getEmployees((employees) => {
        this.selectableEmployees = employees;
        this.employeeApiCallPending = false;
      });
    },

    getReports: function () {
      this.reportsPending = true;

      reportApi.getIPAddressLogReport(
        this.formattedQuery,
        (r) => {
          this.report = r.report;
          this.reportsPending = false;
        },
        (err) => {
          console.log(err);
          this.reportsPending = false;
        },
      );
    },

    csvExport() {
      const options = {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        showTitle: false,
        filename: `ip_address_log_user_${this.selectedEmployeeID}_${this.$moment().format("YYYY-MM-DD_HH-mm-ss")}`,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
      };

      const logToExport = this.report.map((entry) => {
        return _.pick(entry, ["created_at", "ip"]);
      });

      const csvExporter = new ExportToCsv(options);
      csvExporter.generateCsv(logToExport);
    },
  },
};
</script>
